import React from 'react';

export default function KontrakSiswa() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kontrak Siswa</h1>
      <p className="text-gray-500">Halaman Kontrak Siswa</p>
    </div>
  );
}
